import { apiBase, authHeaders } from "./auth";
import { parseGsfError } from "./gsfCommon";

export function normalizeAutomation(raw) {
  if (!raw || typeof raw !== "object") return raw;
  return {
    idCompanyDocAutomation:
      raw.idDocAutomation ??
      raw.id_doc_automation ??
      raw.idCompanyDocAutomation ??
      raw.id_company_doc_automation ??
      null,
    idDocAutomation:
      raw.idDocAutomation ??
      raw.id_doc_automation ??
      raw.idCompanyDocAutomation ??
      raw.id_company_doc_automation ??
      null,
    idEntityCompany: raw.idEntityCompany ?? raw.id_entity_company,
    cdCompanySigla: raw.cdCompanySigla ?? raw.cd_company_sigla ?? "",
    dsBccEmail: raw.dsBccEmail ?? raw.ds_bcc_email ?? "",
    dsDriveFolderUrl: raw.dsDriveFolderUrl ?? raw.ds_drive_folder_url ?? "",
    dsDriveFolderId: raw.dsDriveFolderId ?? raw.ds_drive_folder_id ?? "",
    dsDriveAccountEmail:
      raw.dsDriveAccountEmail ?? raw.ds_drive_account_email ?? "",
    flDriveConnected: raw.flDriveConnected ?? raw.fl_drive_connected ?? "N",
    flGenerateEnabled: raw.flGenerateEnabled ?? raw.fl_generate_enabled ?? "Y",
    flSendEnabled: raw.flSendEnabled ?? raw.fl_send_enabled ?? "Y",
    flUsingAdmFallback:
      raw.flUsingAdmFallback ?? raw.fl_using_adm_fallback ?? "N",
    flPlatformDriveConnected:
      raw.flPlatformDriveConnected ?? raw.fl_platform_drive_connected ?? "N",
    cdDriveProvider:
      raw.cdDriveProvider ?? raw.cd_drive_provider ?? "GOOGLE_DRIVE",
    dsContingencyEmail:
      raw.dsContingencyEmail ?? raw.ds_contingency_email ?? "",
  };
}

export async function fetchDocAutomation(idEntity) {
  const res = await fetch(
    `${apiBase()}/cad/entities/${idEntity}/doc-automation`,
    { headers: authHeaders() }
  );
  if (!res.ok) throw new Error(await parseGsfError(res));
  return normalizeAutomation(await res.json());
}

/** Flags mínimas para o bullet Drive do header (auth: sessão no contrato). */
export async function fetchDriveHeaderStatus(idEntity) {
  // cache-bust: após Ligar/Desligar o bullet do header deve ver flags frescas
  const res = await fetch(
    `${apiBase()}/cad/entities/${idEntity}/drive-header-status?_=${Date.now()}`,
    { headers: authHeaders(), cache: "no-store" }
  );
  if (!res.ok) throw new Error(await parseGsfError(res));
  const raw = await res.json();
  return {
    flDriveConnected: raw.flDriveConnected ?? raw.fl_drive_connected ?? "N",
    flUsingAdmFallback:
      raw.flUsingAdmFallback ?? raw.fl_using_adm_fallback ?? "N",
    flPlatformDriveConnected:
      raw.flPlatformDriveConnected ?? raw.fl_platform_drive_connected ?? "N",
    cdDriveProvider:
      raw.cdDriveProvider ?? raw.cd_drive_provider ?? "GOOGLE_DRIVE",
  };
}

export async function saveDocAutomation(idEntity, body) {
  const res = await fetch(
    `${apiBase()}/cad/entities/${idEntity}/doc-automation`,
    {
      method: "PUT",
      headers: { ...authHeaders(), "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }
  );
  if (!res.ok) throw new Error(await parseGsfError(res));
  return normalizeAutomation(await res.json());
}

export async function fetchDocChannels() {
  const res = await fetch(`${apiBase()}/cad/dom/doc-channels`, {
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(await parseGsfError(res));
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function startDriveOauth(idEntity) {
  const res = await fetch(
    `${apiBase()}/cad/entities/${idEntity}/doc-automation/drive/oauth/start`,
    { headers: authHeaders() }
  );
  if (!res.ok) throw new Error(await parseGsfError(res));
  return res.json();
}

export async function disconnectDrive(idEntity) {
  const res = await fetch(
    `${apiBase()}/cad/entities/${idEntity}/doc-automation/drive/disconnect`,
    { method: "POST", headers: authHeaders() }
  );
  if (!res.ok) throw new Error(await parseGsfError(res));
  return normalizeAutomation(await res.json());
}
